import { IconButton, Radio, Menu, MenuItem, FormControlLabel, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { getStash, resetStashMedias, setStashCurrentPage, setStashSort, setStashType, setFilterToDate } from '../../../redux/actions/stash';
import useDidMountEffect from '../../utils/useDidMountEffect';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

const Filter = ({
    type,
    sort,
    date
}) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);

    const handleShow = (e) => {
        setAnchorEl(e.currentTarget);
        setShow(show => !show);
    };

    const handleChangeSort = e => {
        dispatch(setStashSort(e.target.value));
        dispatch(setStashCurrentPage(1));
        setShow(false);
    };

    const handleChangeType = e => {
        dispatch(setStashType(e.target.value));
        dispatch(setStashCurrentPage(1));
    };

    useDidMountEffect(() => {
        if (type === 'custom') {
            setShowCalendar(true);
        } else {
            dispatch(setFilterToDate(''));
            dispatch(resetStashMedias());
            dispatch(getStash({ reset: true }));
            setShow(false);
        }
    }, [type]);

    useDidMountEffect(() => {
        dispatch(resetStashMedias());
        dispatch(getStash({ reset: true }));
    }, [sort]);

    useEffect(() => {
        const modal = document.getElementById("stash-main-modal").parentElement;

        if(showCalendar) {
            console.log('::show calendar, hide modal');
            modal.style.display = 'none';
        } else {
            console.log('::hide calendar, show modal');
            modal.style.display = 'block';
        }
    }, [showCalendar]);

    // const handleDateChange = (date) => {
    const handleAcceptCalendarDate = (date) => {
        dispatch(setFilterToDate(date));

        // fetch stash media
        dispatch(resetStashMedias());
        dispatch(getStash({ reset: true }));
        setShowCalendar(false);
        setShow(false);
    };

    const handleClickCustomDateOption = () => {
        if (type === 'all') {
            dispatch(setStashType('custom'));
        }

        setShowCalendar(true);
    }

    const close = () => {
        setShowCalendar(false);
        setShow(false);
    }

    return <React.Fragment>
        <span>
            <IconButton
                onClick={handleShow}
                disableRipple
                className="stash-filter-icon"
            >
                <i className="fa-regular fa-bars-sort"></i>
            </IconButton>
        </span>

        <Menu
            id="stash-filter-popup"
            open={show && !showCalendar}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => setShow(false)}
            sx={{
                zIndex: 999999
            }}
        >
            <MenuItem
                disableRipple
            >
                <FormControlLabel
                    value="all"
                    control={<Radio checked={type === "all"} />}
                    // label="All time"
                    label="All"
                    onChange={handleChangeType}
                />
            </MenuItem>
            <MenuItem
                disableRipple
            >
                <FormControlLabel
                    value="custom"
                    control={<Radio checked={type === "custom"} />}
                    // label={date ? date.format('MMM DD, YYYY') : "Custom date"}
                    label={date ? date.format('MMM DD, YYYY') : "Go to date"}
                    // onChange={handleChangeType}
                    onClick={handleClickCustomDateOption}
                />
            </MenuItem>
            <Divider />
            <MenuItem
                disableRipple
            >
                <FormControlLabel
                    value="ASC"
                    control={<Radio checked={sort === 'ASC'} />}
                    label="Ascending"
                    onChange={handleChangeSort}
                />
            </MenuItem>
            <MenuItem
                disableRipple
            >
                <FormControlLabel
                    value="DESC"
                    control={<Radio checked={sort === 'DESC'} />}
                    label="Descending"
                    onChange={handleChangeSort}
                />
            </MenuItem>
        </Menu>

        {
            showCalendar
                ? <div className="createpost-datetime-wrapper">
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <MobileDatePicker
                            open={showCalendar}
                            onAccept={handleAcceptCalendarDate}
                            onClose={close}
                            defaultValue={date !== '' ? date : moment()}
                            disableFuture
                        />
                    </LocalizationProvider>
                </div>
                : null
        }
    </React.Fragment>;
};

const mapStateToProps = (state) => ({
    type: state.stash.filterType,
    sort: state.stash.sort,
    date: state.stash.filterToDate,
});

export default connect(mapStateToProps)(Filter);